import { useGetMainList, CRUD_GET_LIST, Identifier } from "ra-core"
import { createContext, FC, useContext } from "react"
import { RecPatch } from "@/dataProvider/tools"
import { DatabaseResponseDto } from "@/gen/api/encrypt"
import { pages, sorts } from "@/utils/paramsWithGetMainList"


interface EncryptedDatabasesProps {
  encryptedDbMap?: {[k in string]:DatabaseResponseDto&RecPatch},
  ids?: Identifier[],
  refetch: () => void,
}
const EncryptedDatabasesContext = createContext<EncryptedDatabasesProps>({
  encryptedDbMap: {},
  ids: [],
  refetch: () => {},
})


export const EncryptedDatabasesContextProvider: FC = ({ children }) => {
  const { data: encryptedDbMap, ids, refetch } = useGetMainList('encrypted-dbs', pages(), sorts(), {}, { action: CRUD_GET_LIST })
  return (
    <EncryptedDatabasesContext.Provider value={{ encryptedDbMap, ids, refetch }}>
      {children}
    </EncryptedDatabasesContext.Provider>
  )
}


export const useEncryptedDatabasesContext = () => useContext(EncryptedDatabasesContext);

